import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function CopyLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10539_31841)">
        <path
          d="M13.3327 10.7501V14.2501C13.3327 17.1667 12.166 18.3334 9.24935 18.3334H5.74935C2.83268 18.3334 1.66602 17.1667 1.66602 14.2501V10.7501C1.66602 7.83341 2.83268 6.66675 5.74935 6.66675H9.24935C12.166 6.66675 13.3327 7.83341 13.3327 10.7501Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3327 5.75008V9.25008C18.3327 12.1667 17.166 13.3334 14.2493 13.3334H13.3327V10.7501C13.3327 7.83341 12.166 6.66675 9.24935 6.66675H6.66602V5.75008C6.66602 2.83341 7.83268 1.66675 10.7493 1.66675H14.2493C17.166 1.66675 18.3327 2.83341 18.3327 5.75008Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10539_31841">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
